import React, { useEffect, useRef, useState } from 'react';
import { FilterContainer, FilterHeader, PageTitle } from 'resources/styles/TableStyle';

import { createGlobalStyle } from 'styled-components';
import { DateRangePicker } from 'components/commons/DateRangePicker';
import { Row } from 'saladsoft-primitive';
import { ReservationPeriodFilterType } from 'types/CommonTypes';
import ExcelButton from 'components/input/ExcelButton';
import SaladToggleButton from 'components/input/SaladToggleButton';
import { observer } from 'mobx-react-lite';
import { useStoreWrapper } from 'stores/StoreHelper';
import { getUrlParam } from 'libs/helper/utils';
import { setUrlParams, deleteUrlParams } from 'libs/helper/paramsUtil';
import SearchBox from 'components/input/SearchBox';
const GlobalInputStyle = createGlobalStyle`
  .MuiOutlinedInput-input {
    padding: 10px !important;
  }
`;

const ReservationPeriodFilter = observer(
  ({ onClickExcel }: { onClickExcel: (search: ReservationPeriodFilterType) => void }) => {
    const items = [
      { value: 'RESERVATION', label: '예약일기준' },
      { value: 'ARRIVAL', label: '입실일기준' },
      { value: 'DEPARTURE', label: '퇴실일기준' },
      { value: 'CANCELED', label: '취소일기준  ' },
      { value: 'CONFIRMATION', label: '확정일기준  ' },
    ];

    const keyword = useRef<string>('');
    const inputRef = useRef<any>(null);

    const [periodType, setPeriodType] = useState<ReservationPeriodFilterType['periodType']>('ALL');
    const [status, setStatus] = useState<ReservationPeriodFilterType['status']>('ALL');
    const [isSearched, setIsSearched] = useState<boolean>(false);

    const [searchKeyword, setSearchKeyword] = useState<string>('');
    const [itemIndex, setItemIndex] = useState<number>();

    const handleChangeType = (value: string) => {
      setUrlParams({
        periodType: value,
      });
    };

    const [innerSelectedDateRange, setInnerSelectedDateRange] = useState<
      [string | null, string | null]
    >([null, null]);

    const handleChangePeriod = (dateRange: [string | null, string | null]) => {
      if (dateRange[0] && dateRange[1]) {
        setUrlParams({
          startDate: dateRange[0],
          endDate: dateRange[1],
        });

        setInnerSelectedDateRange(dateRange);
      }
    };

    useEffect(() => {
      const from = getUrlParam('startDate');
      const to = getUrlParam('endDate');
      const search = getUrlParam('search');
      if (search) {
        setIsSearched(true);
      } else {
        setIsSearched(false);
      }
      setInnerSelectedDateRange([from, to]);
      setSearchKeyword(search || '');
    }, []);

    /** 만약 특정 SaladToggleButton을 사용할 경우, 파라미터를 검사하여 해당 값을 기본값으로 전달한다. */
    useEffect(() => {
      const periodType = getUrlParam('periodType');
      setItemIndex(periodType ? items.findIndex((item) => item.value === periodType) : 0);
    }, [periodType]);

    useEffect(() => {
      const urlPeriodType = getUrlParam('periodType');
      setPeriodType(urlPeriodType as ReservationPeriodFilterType['periodType']);
    }, [location.search]);

    return (
      <div>
        <GlobalInputStyle />
        <Row justifyContent="space-between" width="100%">
          <FilterContainer>
            <PageTitle>기간별 예약 조회</PageTitle>
            <FilterHeader>
              <SaladToggleButton
                defaultIndex={itemIndex}
                items={items}
                onChange={handleChangeType}
              />
            </FilterHeader>
            <DateRangePicker
              value={innerSelectedDateRange}
              onChange={handleChangePeriod}
              style={{ width: 300 }}
            />
            <SearchBox paramKey="search" placeholder="게스트명" />
          </FilterContainer>
          <ExcelButton
            onClick={() => {
              onClickExcel({
                periodType: periodType,
                status: status,
                dateRange: innerSelectedDateRange,
                search: keyword.current,
              });
            }}
          />
        </Row>
      </div>
    );
  },
);

export default ReservationPeriodFilter;
